import React from "react";

type ISchoolMarkerSvgProps = {
    color: string;
    checked?: boolean;
    dot?: string | null;
    icon?: JSX.Element | null
}

export const ICON_STAR = <polygon
    id="Star"
    fill="#ffffff"
    points="20.357039,27.975671 14.880846,22.637703 22.448758,21.538021 25.833231,14.68033 29.217704,21.538021 36.785615,22.637703 31.309423,27.975671 32.602177,35.513003 25.833231,31.954358 19.064285,35.513003 "
    transform="matrix(1.3239126,0,0,1.3239126,1.2990606,-11.435474)" />


export const ICON_SCHOOL = <path
    d="m 36.584687,6.3251586 c -0.658125,-0.4335448 -1.51125,-0.4335448 -2.169375,0 L 25.945,11.907048 18.291249,13.587036 C 16.950625,13.882086 16,15.050249 16,16.405076 v 17.534482 c 0,1.595686 1.310156,2.890299 2.925,2.890299 h 33.15 c 1.614844,0 2.925,-1.294613 2.925,-2.890299 V 16.405076 c 0,-1.354827 -0.950625,-2.529011 -2.29125,-2.824063 L 45.055,11.907048 Z M 31.6,31.049259 c 0,-2.125574 1.748906,-3.853733 3.9,-3.853733 2.151094,0 3.9,1.728159 3.9,3.853733 v 5.780598 H 31.6 Z M 21.85,17.561196 h 1.95 c 0.53625,0 0.975,0.433545 0.975,0.963434 v 3.853731 c 0,0.529888 -0.43875,0.963434 -0.975,0.963434 h -1.95 c -0.53625,0 -0.975,-0.433546 -0.975,-0.963434 V 18.52463 c 0,-0.529889 0.43875,-0.963434 0.975,-0.963434 z m 24.375,0.963434 c 0,-0.529889 0.43875,-0.963434 0.975,-0.963434 h 1.95 c 0.53625,0 0.975,0.433545 0.975,0.963434 v 3.853731 c 0,0.529888 -0.43875,0.963434 -0.975,0.963434 H 47.2 c -0.53625,0 -0.975,-0.433546 -0.975,-0.963434 z M 21.85,25.268661 h 1.95 c 0.53625,0 0.975,0.433544 0.975,0.963432 v 3.853733 c 0,0.529888 -0.43875,0.963433 -0.975,0.963433 h -1.95 c -0.53625,0 -0.975,-0.433545 -0.975,-0.963433 v -3.853733 c 0,-0.529888 0.43875,-0.963432 0.975,-0.963432 z m 24.375,0.963432 c 0,-0.529888 0.43875,-0.963432 0.975,-0.963432 h 1.95 c 0.53625,0 0.975,0.433544 0.975,0.963432 v 3.853733 c 0,0.529888 -0.43875,0.963433 -0.975,0.963433 H 47.2 c -0.53625,0 -0.975,-0.433545 -0.975,-0.963433 z m -5.3625,-9.63433 c 0,2.926429 -2.400938,5.298883 -5.3625,5.298883 -2.961563,0 -5.3625,-2.372454 -5.3625,-5.298883 0,-2.926427 2.400937,-5.298881 5.3625,-5.298881 2.961562,0 5.3625,2.372454 5.3625,5.298881 z M 35.5,13.707465 c -0.53625,0 -0.975,0.433544 -0.975,0.963432 v 1.926866 c 0,0.529888 0.43875,0.963433 0.975,0.963433 h 1.95 c 0.53625,0 0.975,-0.433545 0.975,-0.963433 0,-0.529888 -0.43875,-0.963433 -0.975,-0.963433 h -0.975 v -0.963433 c 0,-0.529888 -0.43875,-0.963432 -0.975,-0.963432 z"
    fill="#ffffff"
    fillRule="nonzero"
    id="School" />

export const ICON_C = <path
    d="m 48.965922,30.522717 q -0.386364,5.340915 -3.954549,8.4091 -3.545458,3.068185 -9.363646,3.068185 -6.363643,0 -10.022737,-4.272732 -3.636368,-4.295459 -3.636368,-11.772739 v -2.022729 q 0,-4.772732 1.68182,-8.4091 1.68182,-3.636367 4.79546,-5.5681872 3.136366,-1.9545474 7.272734,-1.9545474 5.727279,0 9.227282,3.0681846 3.500004,3.068185 4.045459,8.613645 h -6.818189 q -0.25,-3.204548 -1.795456,-4.636368 -1.522729,-1.454547 -4.659096,-1.454547 -3.409094,0 -5.113641,2.454548 -1.68182,2.431821 -1.727275,7.56819 v 2.500002 q 0,5.363642 1.613638,7.840917 1.636365,2.477275 5.136369,2.477275 3.159094,0 4.70455,-1.431819 1.568184,-1.454547 1.795457,-4.477278 z"
    id="letterC"
    fill="#ffffff" />

export const ICON_L = <path
    d="m 31.565244,36.372265 h 14.875008 v 5.62775 H 24.559746 V 7.9999983 h 7.005498 z"
    id="letterL"
    fill="#ffffff" />

const checkboxSvg = <g id="Checkbox"
    transform="translate(49,38)">
    <rect
        id="blackbox"
        width="22"
        height="22"
        x="0"
        y="0"
        fill="#000000" />
    <rect
        id="whitebox"
        width="18"
        height="18"
        x="2"
        y="2"
        fill="#ffffff" />
    <path
        d="m 16.030403,6.2113636 c 0.498528,0.512821 0.919975,0.9461909 1.357438,1.3960701 C 14.780079,10.270595 12.1563,12.951297 9.5124994,15.652636 7.8046904,13.856215 6.1179036,12.081462 4.4711593,10.350046 4.8225315,9.9538221 5.2179503,9.5080702 5.6644233,9.0055675 6.9477827,10.370683 8.2021115,11.704843 9.487473,13.072022 c 2.222354,-2.330911 4.386646,-4.5999122 6.54293,-6.8606584"
        id="check"
        fill="#000000" />
</g>

function SchoolMarkerSvg({ color, checked = false, dot = null, icon = null }: ISchoolMarkerSvgProps) {
    return <svg
        width="71"
        height="79"
        viewBox="0 0 71 79"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg">
        <title>School Marker</title>
        <g id="Marker"
            fill={color}
            transform="translate(10)">
            <polygon
                id="Triangle"
                points="18,36 0,0 36,0 "
                transform="translate(7.5,33)" />
            <rect
                id="Rectangle"
                x="0"
                y="0"
                width="51"
                height="51" />
        </g>

        {checked && checkboxSvg}

        {dot && <circle
            id="Dot"
            fill={dot}
            cx="35.5"
            cy="69"
            r="10" />}

        {icon}
    </svg >
}

export default SchoolMarkerSvg;